WiseMetering.Views.ShowIntegrationPartner = WiseMetering.Views.Modal.Show.extend({
    buttons: ['close'],
    className: 'mbx-info text-left',
    template: 'templates/integration_partners/show',
    title: () => i18next.t('modal.title.integration_partners.show')
});
